import React, { useState, useEffect, useCallback } from 'react'
import { Alert } from '@mui/material'
import { apiService } from '../../../services/api'
import { Section, ReportTable } from '../../report-shell'

const OrangeOpaskaRawData = () => {
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const [page, setPage] = useState(0)
  const [pageSize, setPageSize] = useState(50)

  const fetchData = useCallback(async () => {
    try {
      setLoading(true); setError(null)
      const response = await apiService.getOrangeOpaskaRawData(pageSize, page * pageSize)
      setData(response.data)
    } catch (err) {
      setError(`Błąd pobierania danych: ${err.message}`)
    } finally { setLoading(false) }
  }, [page, pageSize])

  useEffect(() => { fetchData() }, [fetchData])

  const columns = [
    { field: 'bill_account_id', header: 'Konto klienta', width: '140px', sortable: false },
    { field: 'serial_number',   header: 'IMEI',          width: '170px', sortable: false },
    { field: 'order_number',    header: 'Nr zamówienia', width: '150px', sortable: false },
    { field: 'invoice_date',    header: 'Data faktury',  width: '120px', sortable: false },
    { field: 'move_type',       header: 'Typ',           width: '80px',  sortable: false },
    { field: 'quantity',        header: 'Ilość',         width: '80px',  numeric: true, sortable: false },
    { field: 'material_name',   header: 'Materiał',      width: '1.4fr', minWidth: 200, sortable: false },
    { field: 'plant',           header: 'Plant',         width: '90px',  sortable: false },
  ]

  const rows = (data?.data || []).map((r, i) => ({ id: i, ...r }))

  return (
    <Section title="Czyste dane z raportu" subtitle="Strony stronicowane po stronie serwera.">
      {error && <Alert severity="error" sx={{ m: 2 }}>{error}</Alert>}
      <ReportTable
        rows={rows}
        columns={columns}
        loading={loading}
        density="compact"
        pageSize={pageSize}
        pageSizeOptions={[25, 50, 100]}
        serverPagination
        rowCount={data?.total || 0}
        page={page}
        onPageChange={setPage}
        onPageSizeChange={(n) => { setPageSize(n); setPage(0) }}
      />
    </Section>
  )
}

export default OrangeOpaskaRawData
